import { render, staticRenderFns } from "./z-canvas.vue?vue&type=template&id=670e1f73&"
import script from "./z-canvas.vue?vue&type=script&lang=js&"
export * from "./z-canvas.vue?vue&type=script&lang=js&"
import style0 from "./z-canvas.vue?vue&type=style&index=0&id=670e1f73&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports